import React from 'react';

import PropTypes from 'prop-types';
import { Table, Segment, Header, Icon, Button } from 'semantic-ui-react';

import _isEmpty from 'lodash/isEmpty';

import { reviewShape } from '../../types';
import ReviewsTableRow from '../ReviewsTableRow';

const propTypes = {
  filteredReviews: PropTypes.arrayOf(reviewShape),
  updateReview: PropTypes.func.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleReplyClick: PropTypes.func.isRequired,
  columns: PropTypes.number,
  onClearQuery: PropTypes.func.isRequired,
};

const defaultProps = {
  filteredReviews: [],
  columns: 8,
};

export default function ReviewsTableBody({
  filteredReviews,
  updateReview,
  handleInputChange,
  handleReplyClick,
  columns,
  onClearQuery,
}) {
  if (_isEmpty(filteredReviews)) {
    return (
      <Table.Body>
        <Table.Row>
          <Table.Cell colSpan={columns} textAlign="center">
            <Segment placeholder>
              <Header icon>
                <Icon name="search" />
                No reviews matching your query were found.
              </Header>
              <Button primary onClick={onClearQuery}>
                Clear Query
              </Button>
            </Segment>
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    );
  }
  return (
    <Table.Body>
      {filteredReviews.map((review, index) => (
        <ReviewsTableRow
          key={review.id || review.localId || index}
          review={review}
          reviewIndex={index}
          onInputChange={(e, target) => handleInputChange(e, target, index, updateReview)}
          onReplyClick={() => handleReplyClick(review)}
        />
      ))}
    </Table.Body>
  );
}

ReviewsTableBody.propTypes = propTypes;
ReviewsTableBody.defaultProps = defaultProps;
